export type ShapeData = {
  __typename?: string;
  [key: string]: any;
};

export type Component = {
  id: string;
  content: {
    __typename: string;
    text?: string;
    value?: boolean;
    options?: Array<{ key: string; value: string }>;
    chunks?: Array<Array<Component>>;
    items?: Array<ShapeData>;
    [key: string]: any;
  };
};

export type ShapeContent = {
  name: string;
  shape: {
    identifier: string;
  };
  path: string;
  components: Component[];
};

export class CrystallizeShapeHelper {
  private shapeRawData: ShapeContent;

  constructor(shapeContent: ShapeContent) {
    this.shapeRawData = shapeContent;
  }

  getFlattened(): { [key: string]: any } {
    const flattened: { [key: string]: any } = {};

    this.shapeRawData?.components?.forEach((component) => {
      if (component.content?.__typename === 'ContentChunkContent') {
        const chunkValues = component.content.chunks?.map((chunk) =>
          chunk.reduce(
            (acc, item) => {
              acc[item.id] = this.extractValue(item.content);
              return acc;
            },
            {} as { [key: string]: any },
          ),
        );

        flattened[component.id] = chunkValues;
      } else if (['ItemRelationsContent', 'Product'].includes(component.content?.__typename)) {
        flattened[component.id] = component.content?.items?.map((relationshipItem) => {
          const childShape = new CrystallizeShapeHelper(relationshipItem as ShapeContent);
          return childShape.getFlattened();
        });
      } else {
        flattened[component.id] = this.extractValue(component.content);
      }
    });

    return flattened;
  }

  private extractValue(content: Component['content']): any {
    switch (content?.__typename) {
      case 'SingleLineContent':
        return content.text;
      case 'BooleanContent':
        return content.value ?? null;
      case 'SelectionContent':
        return content.options?.map((opt) => opt.key);
      case 'RichTextContent':
      case 'ImageContent':
        return content;
      case 'ItemRelationsContent':
        return content.items;
      default:
        return content?.text;
    }
  }
}
